import React, { useEffect, useState } from "react";
import Theme from "@/components/Theme";
import Hero from "@/organisms/Hero";
import FeatureSectionTwocol from "@/organisms/FeatureSectionTwocol";
import SwiperSection from "@/components/organisms/SwiperSection";
import Image from "@/components/atoms/Image";
import { GYBNMLogo } from "@/components/atoms/Logo";
import { isMobileScreen } from "@/utils/functions";
import Video from "@/components/atoms/Video";
import LoopText from "@/components/atoms/LoopText";
import VideoModalTrigger from "@/components/molecules/VideoModalTrigger";
import BlogArticles from "@/organisms/BlogArticles";

export default function GrowYourBrand() {
  const seoData = {
    indexing: true,
    title: "Your Brand, Not A Marketplace | AnswerForce",
    description:
      "In online marketplaces, you are placed among a sea of competitors. Your hard-won reputation fades into the background. It's time to take a stand and build your business on your terms.",
    og: {
      title: "Your Brand, Not A Marketplace | AnswerForce",
      description:
        "In online marketplaces, you are placed among a sea of competitors. Your hard-won reputation fades into the background. It's time to take a stand and build your business on your terms.",
      url: "https://www.answerforce.com/grow-your-brand",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/gybnm-og.jpg",
    },
    twitter: {
      title: "Your Brand, Not A Marketplace | AnswerForce",
      description:
        "In online marketplaces, you are placed among a sea of competitors. Your hard-won reputation fades into the background. It's time to take a stand and build your business on your terms.",
      url: "https://www.answerforce.com/grow-your-brand",
      image:
        "https://assets.answerforce.com/answerforce/us/website/images/og/gybnm-og.jpg",
      image_alt: "Grow your brand, Not a marketplace",
    },
  };
  const [isMobile, setIsMobile] = useState(null);

  useEffect(() => {
    setIsMobile(isMobileScreen);
  }, []);

  const loopTextItems = [
    "HVAC",
    "Restoration",
    "Plumbing",
    "Roofing",
    "Construction",
    null,
  ];

  const heroImgData = {
    fileName: "gybnm-hero",
    alt: "Grow your brand, Not a marketplace",
  };

  const heroTitleHasComponent = () => (
    <>
      Grow your <br className="phone-only" /> <LoopText items={loopTextItems} />{" "}
      brand
    </>
  );

  const hero = (
    <Hero
      variant="gybnmHero"
      heroTitle={heroTitleHasComponent()}
      heroContent="Not a marketplace"
      heroImgData={heroImgData}
      hasVideoModalTrigger
      hasComponent
      videoSrc="https://www.youtube.com/embed/DvAW-1xqkhU?autoplay=1"
    />
  );

  const swiperCardData = [
    {
      description:
        "How to make your customers feel heard<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/vfsKixowpXU?autoplay=1",
      image: {
        fileName: "gybnm-customer-experience-2x",
        alt: "GYBNM customer experience",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
    },
    {
      description:
        "How to express gratitude for better engagement<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/QCwVXUVWCos?autoplay=1",
      image: {
        fileName: "gybnm-better-engagement-2x",
        alt: "GYBNM better engagement",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description: "Why it matters to Give Back<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/B4oRV6iXn24?autoplay=1",
      image: {
        fileName: "gybnm-giving-back-2x",
        alt: "GYBNM giving back",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description:
        "3 tools to supercharge your marketing copy<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/CWw3cVAJZvQ?autoplay=1",
      image: {
        fileName: "gybnm-marketing-tools-2x",
        alt: "GYBNM marketing tools",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description:
        "It's time for multi-channel marketing approach<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/wHluEh0JJZ8?autoplay=1",
      image: {
        fileName: "gybnm-marketing-approach-2x",
        alt: "GYBNM marketing approach",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description:
        "The language of loyalty - word of mouth<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/uFsqmoUa8Wk?autoplay=1",
      image: {
        fileName: "gybnm-marketing-loyalty-2x",
        alt: "GYBNM marketing Loyalty",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description: "Telling your brand story<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/fKw2f43Q6uE?autoplay=1",
      image: {
        fileName: "gybnm-branding-story-2x",
        alt: "GYBNM branding story",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description:
        "How to get the most from trade shows<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/xNjOClKBHzc?autoplay=1",
      image: {
        fileName: "gybnm-communication-2x",
        alt: "GYBNM communication",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description: "How to enhance brand loyalty<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/gf3xqmOIciA?autoplay=1",
      image: {
        fileName: "gybnm-branding-loyalty-2x",
        alt: "GYBNM branding loyalty",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description: "Leading from Anywhere<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/yOJDyr1Qy6M?autoplay=1",
      image: {
        fileName: "gybnm-management-lead-2x",
        alt: "GYBNM management lead",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
    {
      description:
        "5 ways to engage and grow your community<span class='dot'>.</span>",
      videoSrc: "https://www.youtube.com/embed/ai5Bq1YmV4A?autoplay=1",
      image: {
        fileName: "gybnm-growth-community-2x",
        alt: "GYBNM growth community",
        desktopWidth: "360",
        mobileWidth: "280",
      },
    },
  ];

  const listOverBgImgData = {
    listData: [
      {
        percent: "82",
        context:
          "of customers want <b>direct communication</b> with the brands they purchase from.",
        bgColor: "grad-orange",
      },
      {
        percent: "72",
        context:
          "of people prefer to <b>buy directly from brands</b> so they don't split profits.",
      },
      {
        percent: "41",
        context:
          "of custumers <b>prioritize pricing</b> as the key factor while browsing a marketplace.",
      },
    ],
    bgImg: {
      fileName: "gybnm-customer-banner",
      altText: "GYBNM customers banner image",
      desktopWidth: "100%",
      mobileWidth: "100%",
    },
    stats: "Source: OnePoll, 2023",
  };

  const cardData = [
    {
      description:
        "3 ways to prepare for hurricane season call surges<span class='dot'>.</span>",
      image: {
        fileName: "blog-restoration-2x",
        alt: "Restoration blog banner",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
      label: "Restoration",
      readTime: "5 mins read",
      href: "https://www.answerforce.com/blog/3-ways-restorers-can-prepare-for-hurricane-season-call-surges/",
    },
    {
      description:
        "The importance of reviews for your plumbing business<span class='dot'>.</span>",
      image: {
        fileName: "blog-plumbing-2x",
        alt: "Plumbing blog banner",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
      label: "Plumbing",
      readTime: "10 mins read",
      href: "https://www.answerforce.com/blog/the-importance-of-getting-reviews-for-your-plumbing-business/",
    },
    {
      description:
        "3 reasons why your business should be using integrations<span class='dot'>.</span>",
      image: {
        fileName: "blog-integrations-2x",
        alt: "Integrations blog banner",
        desktopWidth: "360",
        mobileWidth: "280",
        has2XWebp: "true",
      },
      label: "Integrations",
      readTime: "5 mins read",
      href: "https://www.answerforce.com/blog/3-reasons-why-your-business-should-be-using-integrations/",
    },
  ];

  return (
    <Theme mainClassName="main" hero={hero} seo={seoData}>
      <FeatureSectionTwocol
        bgColor="white"
        title="Lifelong customer relationships<span class='dot'>.</span>"
        image={{
          fileName: "customer-relationship-01",
          altText: "Customer Relationship",
          desktopWidth: 500,
          mobileWidth: 335,
        }}
        content={[
          "Great service, strong relationships, fair prices, and happy customers. You've earned your reputation. So how do you make sure it works hard for your business?",
          "Take control of your business growth and don't rely on online directories and third-party administrators to show customers what you can do. ",
        ]}
      />
      <section className="bc-grad-blue pv-15-d pv-8">
        <div className="container ps-r card">
          <Image
            fileName="gybnm-customer-exp-thumb-01"
            fileFormat="jpg"
            desktopWidth="100%"
            mobileWidth="100%"
            alt="GYBNM customer experience thumbnail youtube"
            imgStyle="br-16"
          />
          <VideoModalTrigger
            isBtnCenter
            btnSizeDesk="114"
            btnSizeMob="60"
            src="https://www.youtube.com/embed/aHKK-aTLV_Y?autoplay=1"
          />
        </div>
      </section>
      <FeatureSectionTwocol
        bgColor="white"
        title="You're built to stand apart, not in line<span class='dot'>.</span>"
        isImageOnLeft={false}
        contentAdjToTitle={[
          "With marketplaces, you're forced to compete on price alone - but your pricing reflects years of hard work and expertise. It's time to invest in standing apart from the competition.",
        ]}
        listOverBgImgData={listOverBgImgData}
      />
      <SwiperSection
        className="gybnm overflow-hidden"
        title="Take back control<span class='dot'>.</span>"
        content="Hear from our marketing, design, and customer service<br class='desktop-only' /> experts about how to grow your business in 2024."
        swiperCardData={swiperCardData}
      />
      <section className="bc-grad-blue pv-15-d pv-8">
        <div className="container ps-r">
          <Video
            srcDesk="https://assets.answerforce.com/answerforce/us/website/media/gybnm-clip-desk.mp4"
            srcMob="https://assets.answerforce.com/answerforce/us/website/media/gybnm-clip-mob.mp4"
            posterSrcDesk="https://assets.answerforce.com/answerforce/us/website/images/desktop/gybnm-poster-desk-2x.jpg"
            posterSrcMob="https://assets.answerforce.com/answerforce/us/website/images/mobile/gybnm-poster-mob-2x.jpg"
          />
          <GYBNMLogo
            className="ps-centered"
            width={`${isMobile ? "200" : "356"}`}
          />
        </div>
      </section>
      <BlogArticles
        title="Powerful tips to grow your brand<span class='dot'>.</span>"
        cardData={cardData}
        linkText="See all business growth articles"
        href="https://www.answerforce.com/blog/us/category/business-growth/"
      />
    </Theme>
  );
}
